import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const PROFILES_DELETE_REQUEST = 'DELETE_PROFILES_REQUEST';
export const PROFILES_DELETE_FAILURE = 'DELETE_PROFILES_FAILURE';
export const PROFILES_DELETE_SUCCESS = 'DELETE_PROFILES_SUCCESS';

export const deleteProfile = (id) => {
    const params = [];
    params['id'] = id;
    return function(dispatch) {
        dispatch(deleteRequest());
        return axios(apiRequestOptions(apiPath.PROFILES.DELETE, null, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(deleteSuccess(id));
                dispatch(addSuccessMessage('Profile successfully deleted'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(deleteFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const deleteRequest = () => {
    return {
        type: PROFILES_DELETE_REQUEST,
    }
};

const deleteFailure = (error) => {
    return {
        type: PROFILES_DELETE_FAILURE,
        error,
    }
};

// `profile` — the id the profiles list drops (it was sent as `sportsman`,
// which nothing read, so a deleted profile stayed listed until a re-read —
// caught by the full E2E run, 21 Oct 2026).
const deleteSuccess = (profile) => {
    return {
        type: PROFILES_DELETE_SUCCESS,
        profile,
    }
};

/**
 * Whether «Видалити профіль» may be offered — `{deletable, blockers}` from
 * the server (ProfileDeletion), asked when a profile's menu opens. Resolves
 * null when it could not be read: the item then stays disabled.
 */
export const fetchProfileDeletability = id => () => {
    const params = [];
    params['id'] = id;

    return axios(apiRequestOptions(apiPath.PROFILES.DELETABILITY, null, { params }))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(() => null);
};

